export enum SlotStatus {
    less ='less',
    enought = 'enought',
    closed = 'closed',
}